import React from "react";

const AppPagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  if (!totalItems || totalPages <= 0) return null;

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage + 1;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, totalItems);

  const getVisiblePages = () => {
    const maxVisible = 5;
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };

  const visiblePages = getVisiblePages();
  const firstVisiblePage = visiblePages[0];
  const lastVisiblePage = visiblePages[visiblePages.length - 1];

  return (
    <div className="app-pagination d-flex flex-wrap justify-content-between align-items-center gap-3 mt-3 pt-3">
      <div className="app-pagination-info">
        Showing <strong>{indexOfFirstItem}</strong>–<strong>{indexOfLastItem}</strong> of{" "}
        <strong>{totalItems}</strong> entries
      </div>

      <div className="d-flex align-items-center gap-1 flex-wrap">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Previous
        </button>

        {firstVisiblePage > 1 && (
          <>
            <button
              type="button"
              className="btn btn-outline-primary btn-sm app-page-button"
              onClick={() => onPageChange(1)}
            >
              1
            </button>
            {firstVisiblePage > 2 && <span className="app-pagination-ellipsis">…</span>}
          </>
        )}

        {visiblePages.map((pageNumber) => (
          <button
            type="button"
            key={pageNumber}
            className={`btn btn-sm app-page-button ${
              currentPage === pageNumber ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => onPageChange(pageNumber)}
            aria-current={currentPage === pageNumber ? "page" : undefined}
          >
            {pageNumber}
          </button>
        ))}

        {lastVisiblePage < totalPages && (
          <>
            {lastVisiblePage < totalPages - 1 && (
              <span className="app-pagination-ellipsis">…</span>
            )}
            <button
              type="button"
              className="btn btn-outline-primary btn-sm app-page-button"
              onClick={() => onPageChange(totalPages)}
            >
              {totalPages}
            </button>
          </>
        )}

        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AppPagination;
